import { LazyLoad } from '@petconsole/pure-fe-mui';

const PetWorkplaceAdmin = LazyLoad(() => import('./PetWorkplaceAdmin'));

export { PetWorkplaceAdmin };
